import { DUR, DIST, FX } from "./tokens";

// ---------------------------------------------------------------------------
// PRESETS — declarative recipes consumed by the hooks. Each entrance preset is
// { from, to } for gsap.fromTo. Behavioral presets (parallax, floating, hover,
// magnetic, glow) export their parameters; the hooks own the mechanics.
// All presets animate ONLY transform / opacity / filter / box-shadow — never
// layout properties.
// ---------------------------------------------------------------------------

export const ENTRANCES = {
    // The house entrance: opacity + blur + translateY + scale together —
    // reads as a focus-pull, not a fade-in.
    cinematic: {
        from: { opacity: 0, y: DIST.rise, scale: 0.985, filter: `blur(${FX.blur}px)` },
        to: { opacity: 1, y: 0, scale: 1, filter: "blur(0px)", duration: DUR.slow * 1.15, clearProps: "filter" },
    },
    // The image entrance: clip-path curtain opens while the image settles from
    // a restrained 1.06 scale and sheds a soft blur. No zoom theatrics, no fade.
    maskReveal: {
        from: { clipPath: "inset(10% 6% 10% 6%)", scale: 1.06, filter: "blur(8px)", opacity: 0.001 },
        to: { clipPath: "inset(0% 0% 0% 0%)", scale: 1, filter: "blur(0px)", opacity: 1,
              duration: DUR.slow * 1.35, clearProps: "filter,clipPath" },
    },
    fadeUp: {
        from: { opacity: 0, y: DIST.rise },
        to: { opacity: 1, y: 0, duration: DUR.slow },
    },
    fadeBlur: {
        from: { opacity: 0, filter: `blur(${FX.blur}px)` },
        to: { opacity: 1, filter: "blur(0px)", duration: DUR.slow },
    },
    scaleIn: {
        from: { opacity: 0, scale: FX.scaleIn },
        to: { opacity: 1, scale: 1, duration: DUR.slow },
    },
    slideReveal: {
        from: { opacity: 0, x: DIST.slide, clipPath: "inset(0 100% 0 0)" },
        to: { opacity: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: DUR.slow },
    },
};

export const PARALLAX = {
    scrollFactor: DIST.parallaxScroll, // element moves this fraction of scroll
    mouseMax: DIST.parallaxMouse,      // px max offset toward pointer
    mouseDuration: DUR.medium,
};

export const FLOATING = {
    radius: DIST.float,
    durationMin: DUR.floatMin,
    durationMax: DUR.floatMax,
};

export const HOVER_LIFT = {
    y: DIST.liftY,
    scale: FX.liftScale,
    duration: DUR.fast,
};

export const MAGNETIC = {
    strength: DIST.magnetic,
    radius: DIST.magneticRadius,
    snapDuration: DUR.medium,
};

export const BUTTON_GLOW = {
    boxShadow: FX.glow,
    boxShadowActive: FX.glowStrong,
    duration: DUR.fast,
};
